import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.radiologylist, { type, payload }) {
    switch (type) {
        case types.RADIOLOGYLIST_REQUEST:
            return {
                ...initialState.radiologylist,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.RADIOLOGYLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.RADIOLOGYLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}